import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./components/atoms/button/StbButton.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./utilities/authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);
const dashboardBackgroundColor = process.env.REACT_APP_DASHBOARD_BACKGROUND_COLOR?.trim();

if (dashboardBackgroundColor) {
  document.documentElement.style.setProperty(
    "--dashboard-background-color",
    dashboardBackgroundColor
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App pca={msalInstance} />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();